/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_DaysInputs */

const en_us2_profile_row_days = /** @type {(inputs: Profile_Row_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which days`)
};

const pt_br2_profile_row_days = /** @type {(inputs: Profile_Row_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais dias`)
};

const es_419_profile_row_days = /** @type {(inputs: Profile_Row_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué días`)
};

const pt_pt2_profile_row_days = /** @type {(inputs: Profile_Row_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dias`)
};

const fr_fr2_profile_row_days = /** @type {(inputs: Profile_Row_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels jours`)
};

const de_de2_profile_row_days = /** @type {(inputs: Profile_Row_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Tage`)
};

const it_it2_profile_row_days = /** @type {(inputs: Profile_Row_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali giorni`)
};

/**
* | output |
* | --- |
* | "Which days" |
*
* @param {Profile_Row_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_days = /** @type {((inputs?: Profile_Row_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_days(inputs)
	if (locale === "es-419") return es_419_profile_row_days(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_days(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_days(inputs)
	if (locale === "de-DE") return de_de2_profile_row_days(inputs)
	if (locale === "it-IT") return it_it2_profile_row_days(inputs)
	return en_us2_profile_row_days(inputs)
});
export { profile_row_days as "profile.row_days" }